<template>
  <div>
    <v-row class="px-4">
      <v-col cols="12" sm="6" md="2">
        <v-text-field
          v-model="date"
          @change="fetchData()"
          type="date"
          outlined
          dense
          label="Data"
        ></v-text-field>
      </v-col>
      <v-col cols="1">
        <v-btn @click="fetchData()" icon>
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="items"
      :options.sync="options"
      :serverItemsLength="serverItemsLength"
      :sortable="false"
    >
      <template v-slot:item.data="{ item }">
        <span
          :class="{
            'red--text': item.atrasado,
            'green--text': item.data_entrega
          }"
        >
          {{ item.data }}
        </span>
        <v-icon color="red" v-if="item.atrasado" right>mdi-alert</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="!item.data_entrega"
          @click="transferirItem(item)"
          color="primary"
          icon
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn
          v-if="!item.data_entrega"
          @click="excluirTransferencia(item)"
          color="red"
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.local_estoque_destino_nome="{ item }">
        <router-link
          v-if="item.local_estoque_destino_id !== localDeEstoqueId"
          :to="{
            name: 'locais_de_estoque_page',
            params: { id: item.local_estoque_destino_id }
          }"
          v-text="item.local_estoque_destino_nome"
        ></router-link>
        <span v-text="item.local_estoque_destino_nome" v-else />
      </template>
      <template v-slot:item.local_estoque_origem_nome="{ item }">
        <router-link
          v-if="item.local_estoque_origem_id !== localDeEstoqueId"
          :to="{
            name: 'locais_de_estoque_page',
            params: { id: item.local_estoque_origem_id }
          }"
          v-text="item.local_estoque_origem_nome"
        ></router-link>
        <span v-text="item.local_estoque_origem_nome" v-else />
      </template>
    </v-data-table>
  </div>
</template>

<script>
import api from "@/services/locacoes.js";
import pagination from "../../../mixins/Pagination";

export default {
  mixins: [pagination],

  components: {},

  props: {
    localDeEstoqueId: Number,
    status: {
      type: String,
      default: "todos"
    }
  },

  data() {
    return {
      headers: [
        {
          text: "Data",
          value: "data",
          sortable: false
        },
        {
          text: "Origem",
          value: "local_estoque_origem_nome",
          sortable: false
        },
        {
          text: "Destino",
          value: "local_estoque_destino_nome",
          sortable: false
        },
        {
          text: "Produto",
          value: "produto_nome",
          sortable: false
        },
        {
          text: "Quantidade",
          value: "quantidade",
          sortable: false
        },
        {
          text: "Ações",
          value: "actions",
          sortable: false
        }
      ],

      date: "",

      items: [],

      loading: false
    };
  },

  methods: {
    async fetchData() {
      const options = this.options;

      this.loading = true;

      const response = await this.getFecher(options);

      this.fillPaginationFromResponse(response);

      this.items = response.data;

      this.loading = false;
    },

    getFecher(options) {
      options = {
        ...this.getPaginationParams(options),
        status: this.status,
        date: this.date
      };

      if (this.localDeEstoqueId) {
        return api.transferencias.indexarPorLocalDeEstoque(
          this.localDeEstoqueId,
          options
        );
      }

      return api.transferencias.indexar(options);
    },

    async excluirTransferencia(item) {
      if (!confirm("Remover transferência?")) {
        return;
      }

      await api.transferencias.remover(item.id);

      this.fetchData();

      this.$emit("excluido");
    },

    async transferirItem(item) {
      if (!confirm("Confirmar transferência?")) {
        return;
      }

      await api.transferencias.transferir(item.id);

      this.fetchData();

      this.$emit("transferido");
    }
  },

  watch: {
    status(value) {
      this.options = { ...this.options, page: 1 };
    }
  },

  computed: {}
};
</script>
